import type {
  BuyerRelationshipCreateParametersType,
  BuyerRelationshipCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useBuyerRelationshipCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: BuyerRelationshipCreateParametersType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `buyer-relationships`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as BuyerRelationshipCreateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Relationships],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.SupplierDistance],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.SupplierDistance],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.BuyerRelationship],
      });
    },
  });
};
